import axios from 'axios'
import Geohash from 'latlon-geohash'

import { encode, decode } from './encode'

const atlastoriesApi = process.env.VUE_APP_ATLAS

export const langs = () => {
  return axios.get(atlastoriesApi + 'langs')
}

export const markers = query => {
  return new Promise((resolve, reject) => {
    const url = atlastoriesApi + 'markers'
    axios.post(url, query)
      .then(res => {
        for (let m of res.data) {
          m.hash = Geohash.encode(m.coords[0], m.coords[1], 6)
          m._id = m.lang + '-' + m.wiki
        }
        resolve(res.data)
      })
      .catch(err => reject(err))
  })
}

export const markersSecret = query => {
  return new Promise((resolve, reject) => {
    encode(query).then(q => {
      const url = atlastoriesApi + 'markers'
      const headers = { 'X-Application-Query': q }
      axios.get(url, { headers }).then(res => {
        decode(res.data.data).then(o => {
          resolve(JSON.parse(o))
        })
      }).catch(err => reject(err))
    })
  })
}

export const cloudImage = (src, w = 320, h, c = true) => {
  if (!src) return null
  let url = atlastoriesApi + 'image/' + src
  url += '?w=' + w
  if (h) url += '&h=' + h
  if (c && h) url += '&func=crop'
  return url
}

export const terms = version => {
  let url = atlastoriesApi + 'terms'
  if (version) url += '?v=' + version
  return axios.get(url)
}

export const article = wiki => {
  return axios.get(atlastoriesApi + 'article/' + wiki)
}
